module.exports = __webpack_public_path__ + "static/media/ally_pro_web_4.edbaf8a2.jpg";